import React from 'react';
import { Professional } from '../Professional';
import { OnlineStatus } from '../OnlineStatus';
import * as Styles from './styles';
export const SellerDetails = _ref => {
  let {
    isProfessionalAd,
    isOnline
  } = _ref;
  if (!isProfessionalAd && !isOnline) {
    return React.createElement("div", {
      style: {
        height: '16px'
      }
    });
  }
  return React.createElement(Styles.Details, null, React.createElement(Professional, null, isProfessionalAd), React.createElement(OnlineStatus, null, isOnline));
};